import { connect } from 'react-redux';
import { get } from 'lodash';

import { SUPERUSER } from 'lib/auth';
import SuperuserMsg from '../components/SuperuserMsg';

export default connect(
  state => ({
    isSuperuser: state.user.authenticationLevel === SUPERUSER,
    customerLogin: get(state, 'user.customerDetails.email'),
  })
)(SuperuserMsg);

